import { Link } from "@inertiajs/react";
import ContentLayout from "../shared/ContentLayout";
import PageHeader from "../shared/PageHeader";
import MediaGroupCard from "../MediaGroupCard";

interface Attachment {
  id: number
  title: string | null
  description: string | null
  public_url: string
  thumbnail_url: string | null
  filename?: string
  created_at: string
}

interface AttachmentGroup {
  id: number
  title: string
  description: string | null
  recent_attachments: Attachment[]
  created_at: string
  updated_at: string
}

export default function MediaIndex({ attachmentGroups }: { attachmentGroups: AttachmentGroup[] }) {
  const renderBreadcrumbs = () => (
    <div className="breadcrumbs text-sm">
      <ul>
        <li>
          <Link href="/" className="link link-primary">
            Home
          </Link>
        </li>
        <li>
          <span>Media</span>
        </li>
      </ul>
    </div>
  );

  return (
    <ContentLayout breadcrumbs={renderBreadcrumbs()}>
      <div className="p-3 sm:p-4 max-w-4xl">
        <PageHeader title="Media" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {attachmentGroups.map((attachmentGroup: AttachmentGroup) => (
            <MediaGroupCard
              key={`media-group-card-${attachmentGroup.id}`}
              attachmentGroup={attachmentGroup}
            />
          ))}
        </div>
      </div>
    </ContentLayout>
  )
}
